import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslateContext } from "../../contexts/translate.context";
import CondominiumHeader from "../headers/condominium.header";
import LostAndFoundCondominiumForm from "./forms/lost-and-found.condominium.form";
import LostAndFoundCondominiumList from "./lists/lostAndFound.condominium.list";

export interface ILostAndFoundCondominiumProps {
    viewOnly?: boolean
}

export const LostAndFoundCondominium: React.FC<ILostAndFoundCondominiumProps> = (props: ILostAndFoundCondominiumProps) => {

    const { memberId } = useParams();
    const { display } = useTranslateContext();

    const title = display.title.lost_and_found;
    const description = '';

    let reloadPage = false;
    const [ isLoading, setLoading ] = useState(false);
    const [ recordSelected, setRecordSelected ] = useState({ param : memberId || '', selected : ((memberId === 'new') || (memberId === '0') || (!Number.isNaN(Number.parseInt(memberId ||'')))) });

    function setSelected(isRecord: boolean, recordId: string) {
        setRecordSelected({ param : recordId, selected : isRecord });
    }

    async function initialize() {
    }
    
    useEffect(() => {
        if (!isLoading && !reloadPage) {
            initialize();
            setLoading(true);
        }

        return () => {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            reloadPage = !reloadPage;
        }
    }, []);
    
    return (
        <div className="page">
            <CondominiumHeader title={title} description={description} />
            {(recordSelected.selected) ? (
                <LostAndFoundCondominiumForm 
                    title={title}
                    identifier={recordSelected.param}
                    setRecord={(event: any) => {
                        event.preventDefault();

                        setSelected(false, '0');
                    }}
                    viewOnly={props.viewOnly}
                />
            ) : (
                <LostAndFoundCondominiumList
                    title={title}
                    setRecord={(event: any, recordId: string) => { 
                        event.preventDefault();
        
                        setSelected(true, recordId); 
                    }}
                    viewOnly={props.viewOnly}
                />
            )}
        </div>
    )
}

export default LostAndFoundCondominium;
